export default "__VITE_ASSET__Bl$s57XP__"